import React, { useEffect, useRef, useState } from 'react';
import { cn } from '../../lib/utils';
import { MockupItem, MOCKUPS } from './mockups';
import './effects/LandingEffects.css';

export function InterfaceMockups() {
  const titleRef = useRef<HTMLHeadingElement>(null);
  const [isTitleVisible, setIsTitleVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsTitleVisible(true);
          observer.disconnect();
        }
      },
      {
        threshold: 0.2,
      }
    );

    if (titleRef.current) {
      observer.observe(titleRef.current);
    }

    return () => {
      if (titleRef.current) {
        observer.disconnect();
      }
    };
  }, []);

  return (
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-40">
      <h2
        ref={titleRef}
        className={cn(
          "text-4xl font-bold text-white text-center mb-24 font-['Sora'] opacity-0",
          isTitleVisible && 'animate-fade-in'
        )}
      >
        Exactly what you need. No more, no less.
      </h2>

      <div className="space-y-40">
        {MOCKUPS.map((mockup, index) => (
          <MockupItem key={mockup.type} mockup={mockup} index={index} />
        ))}
      </div>
    </div>
  );
}
